import { render, staticRenderFns } from "./categorySelector.vue?vue&type=template&id=6c6e664e&scoped=true"
import script from "./categorySelector.vue?vue&type=script&lang=js"
export * from "./categorySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e664e",
  null
  
)

export default component.exports